import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { PAGINATION_SIZE } from "../../config";

function SessionsTable({ sessions, onViewSession }) {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedSession, setSelectedSession] = React.useState(null);

  // Calculate page count
  const pageCount = !sessions ? 0 :  sessions.length === 0 ? 1 :
      Math.ceil(sessions.length / PAGINATION_SIZE);

  // Get paginated data
  const displaySessions = sessions.slice(
      (currentPage - 1) * PAGINATION_SIZE,
      currentPage * PAGINATION_SIZE
  );

  const handlePagination = (isForward) => {
    if (isForward && currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
    }
    if (!isForward && currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const calculateDuration = (startTime, stopTime) => {
    const start = new Date(startTime);
    const stop = new Date(stopTime);
    const durationMs = stop - start;

    const minutes = Math.floor(durationMs / 60000);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours}h ${remainingMinutes}m`;
  };

  const handleRowClick = (session) => {
    setSelectedSession(session.id === selectedSession ? null : session.id);
  };

  return (
      <div className="sessions-table-container">
        <div className="card-header">Sessions</div>

        <Paper className="table-wrapper">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>End Time</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Device</TableCell>
                <TableCell>Files</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displaySessions.map((session) => (
                  <TableRow
                      key={session.id}
                      onClick={() => handleRowClick(session)}
                      selected={selectedSession === session.id}
                      className="tableRow"
                  >
                    <TableCell>{session.sessionName}</TableCell>
                    <TableCell>{session.sessionOwnerEmail}</TableCell>
                    <TableCell>{formatDateTime(session.sessionStart)}</TableCell>
                    <TableCell>{formatDateTime(session.sessionStop)}</TableCell>
                    <TableCell>{calculateDuration(session.sessionStart, session.sessionStop)}</TableCell>
                    <TableCell>{session.sessionDevice}</TableCell>
                    <TableCell>{session.artifacts.length}</TableCell>
                    <TableCell align="right">
                      <div className="actions">
                        <Button
                            className="action-button view-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              onViewSession(session.id);
                            }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>

          <div className="pagination-controls">
            <IconButton
                className={`pagination-button ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={() => handlePagination(false)}
                disabled={currentPage === 1}
            >
              <SkipPreviousIcon />
            </IconButton>
            <span className="pagination-info">{`Page ${currentPage} of ${pageCount}`}</span>
            <IconButton
                className={`pagination-button ${currentPage === pageCount ? 'disabled' : ''}`}
                onClick={() => handlePagination(true)}
                disabled={currentPage === pageCount}
            >
              <SkipNextIcon />
            </IconButton>
          </div>
        </Paper>
      </div>
  );
}

export default SessionsTable;